export default "__VITE_ASSET__DEflCpCb__"